import { createFileRoute } from "@tanstack/react-router";
import { MeteoDashboardPage } from "@/components/meteo-dashboard-page";

export const Route = createFileRoute("/dashboard")({
  head: () => ({
    meta: [
      { title: "Your Flood Risk Dashboard | Meteo" },
      {
        name: "description",
        content:
          "Monitor real-time flood risk for your saved locations in Kenya. View alerts, risk maps and 72-hour forecasts. Sign up free.",
      },
      { name: "robots", content: "index, follow" },
      {
        tagName: "link",
        rel: "canonical",
        href: "https://meteo.co.ke/dashboard",
      },
      { property: "og:title", content: "Your Flood Risk Dashboard | Meteo" },
      {
        property: "og:description",
        content:
          "Monitor real-time flood risk for your saved locations in Kenya. View alerts, risk maps and 72-hour forecasts. Sign up free.",
      },
      { property: "og:url", content: "https://meteo.co.ke/dashboard" },
      { property: "og:type", content: "website" },
    ],
  }),
  component: MeteoDashboardPage,
});
